export const ru = {
  uploading: "Загрузка... ",
  uploaded: "загруженное",
  fetching: "Скачиваем изображение с $1$... ",
  poweredBy: "Стало возможным благодаря $1$",
  needHelp: "Нужна помощь?",
  units: {
    px: "px",
    "%": "%",
    deg: "°"
  },
  errors: {
    response_not_ok: "Произошла ошибка при получении этого файла",
    unable_to_search: "Произошла ошибка при поиске",
    invalid_service_url: "Это не URL $1$",
    invalid_url: "Этот URL недействителен",
    upload_aborted: "Ваша загрузка была отменена",
    upload_error: "Произошла ошибка при загрузке этого файла",
    file_type_not_allowed: "Этот тип файла не поддерживается",
    file_too_large: "Файл должен быть не более $1$"
  },
  help: {
    loading: "Загрузка...",
    close: "Закрыть"
  },
  services: {
    default: {
      heading: "Выберите изображение"
    },
    local: {
      title: "Выберите файл",
      button: "Выберите файл",
      or: "или",
      drop: "Перетащите файл сюда, чтобы загрузить"
    },
    camera: {
      title: "Камера",
      button: "Cделать фото",
      switch: "Переключить камеру",
      waiting: "Жду разрешения камеры...",
      unableToRead:
        "Мы не можем получить доступ к вашей камере. Это может быть связано с тем, что вы не предоставили разрешение, или ваше устройство не поддерживает доступ к камере."
    },
    microlink: {
      button: "Скачать из $1$",
      label: "Ссылка на $1$ $2$",
      placeholder: "Введите ссылку на $1$ $2$",
      type: "пост"
    },
    url: {
      title: "Ссылка",
      label: "Ссылка на изображение",
      placeholder: "Введите ссылку на изображение",
      button: "Скачать изображение"
    },
    instagram: {
      title: "Instagram"
    },
    facebook: {
      title: "Facebook"
    },
    flickr: {
      title: "Flickr",
      type: "фото"
    },
    ninegag: {
      title: "9GAG",
      type: "фото"
    },
    deviantart: {
      title: "DeviantArt"
    },
    artstation: {
      title: "ArtStation"
    },
    twitter: {
      title: "Twitter",
      type: "фото твит"
    },
    pinterest: {
      title: "Pinterest",
      type: "pin"
    },
    flipboard: {
      title: "Flipboard",
      type: "статья"
    },
    fotki: {
      title: "Fotki",
      type: "фото"
    },
    linkedin: {
      title: "LinkedIn"
    },
    reddit: {
      title: "Reddit"
    },
    tumblr: {
      title: "Tumblr"
    },
    weheartit: {
      title: "We Heart It"
    },
    screenshot: {
      title: "Скриншот",
      button: "Сделать скриншот",
      label: "Ссылка на сайт",
      placeholder: "Введите ссылку",
      loading: "Скриншотим..."
    },
    search: {
      button: "Поиск на $1$",
      label: "Поиск изображений",
      placeholder: "",
      imagesPoweredBy: "картинки предоставлены $1$"
    },
    giphy: {
      title: "GIPHY"
    },
    unsplash: {
      title: "Unsplash"
    },
    pixabay: {
      title: "Pixabay"
    },
    pexels: {
      title: "Pexels"
    }
  },
  effects: {
    preview: {
      title: "пример"
    },
    filters: {
      title: "Фильтры"
    },
    crop: {
      title: "Обрезать",
      aspectRatios: {
        free: "Свободный",
        square: "Квадрат"
      }
    },
    rotate: {
      title: "Поворот"
    },
    flip: {
      title: "Отразить",
      buttons: {
        horizontal: "Горизонтально",
        vertical: "Вертикально"
      }
    },
    sharpen: {
      title: "Резкость"
    },
    blur: {
      title: "Размытие"
    },
    brightness: {
      title: "Яркость"
    },
    contrast: {
      title: "Контраст"
    },
    grayscale: {
      title: "Оттенки серого"
    },
    "hue-rotate": {
      title: "Повернуть оттенок"
    },
    invert: {
      title: "Инверсия"
    },
    saturate: {
      title: "Насыщенность"
    },
    sepia: {
      title: "Сепия"
    }
  }
};
